export enum BotPartSlot {
  HELMET = 'helmet',
  RUDDER = 'rudder',
  PLATFORM = 'platform',
  TREADS = 'treads'
}

export type BotPartSlotValue = BotPartSlot;

/**
 * Maps atlas/skeleton slot-like names to BotPartSlot.
 * Used when deriving part slot from spine atlas + JSON (e.g. for imports before REST config).
 * partSkin names use helmet/body/legs/tail; this normalizes to our enum.
 */
export const ATLAS_SLOT_NAME_TO_PART_SLOT: Record<string, BotPartSlot> = {
  helmet: BotPartSlot.HELMET,
  head: BotPartSlot.HELMET,
  platform: BotPartSlot.PLATFORM,
  body: BotPartSlot.PLATFORM,
  treads: BotPartSlot.TREADS,
  legs: BotPartSlot.TREADS,
  rudder: BotPartSlot.RUDDER,
  tail: BotPartSlot.RUDDER
};

export function isBotPartSlot(slot: string): slot is BotPartSlot {
  return Object.values(BotPartSlot).includes(slot as BotPartSlot);
}

/**
 * Resolve an atlas/skeleton slot-like name to BotPartSlot, or undefined if unknown.
 */
export function atlasSlotNameToPartSlot(name: string): BotPartSlot | undefined {
  const normalized = name.toLowerCase().trim();
  return ATLAS_SLOT_NAME_TO_PART_SLOT[normalized];
}
